export class Words {
    _id:string;
    partId:string;
    word:string;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/words.ts